// css
import styles from './index.module.scss';

// components
import { Breadcrumbs, Text, Pill, Image } from '@mantine/core';
import { Smartphone, Heart, Gamepad2 } from 'lucide-react';

// hooks
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

export default function GameDescription({ game, isMobile = false }) {
    const { categoryClickData } = useSelector((state) => state.game);
    const router = useRouter();

    // 路由跳转
    const routerPush = (path) => {
        if (path.startsWith('/')) {
            router.push(path);
        } else {
            router.push(`/game/${path}`);
        }
    };

    // 生成面包屑路径数据
    const getBreadcrumbData = (game) => {
        const { currentPath } = categoryClickData;
        const categorie = game.categories?.some((category) => category.slug === currentPath) ? { slug: currentPath } : game.categories?.[0] || null;

        if (!categorie) {
            return [{ name: 'Gameyeap', href: '/' }];
        } else {
            const [slug, parentSlug] = [categorie.slug, categorie.parent?.slug];
            const pathArray = [
                { name: 'Gameyeap', href: '/' },
                { name: slug, href: slug },
                { name: parentSlug, href: `${slug}/${parentSlug}` }
            ];
            return pathArray.filter(item => item.name); // 过滤掉空的项目
        }
    };

    // 格式化游戏路径（UI 渲染）
    const formatPath = (game) => {
        const breadcrumbData = getBreadcrumbData(game);
        
        if (breadcrumbData.length === 1) {
            return (<a className={styles.path_item} onClick={() => routerPush('/')}>Gameyeap</a>);
        } else {
            const pathItems = breadcrumbData.map((item, index) => {
                return (
                    <Text key={index} component="a" className={styles.path_item} onClick={() => routerPush(item.href)}>
                        {item.name}
                    </Text>
                )
            });
            return (
                <Breadcrumbs>
                    { pathItems }
                </Breadcrumbs>
            );
        }
    };

    // 游戏详情信息数组
    const gameDetailInfo = [
        {
            label: 'Developer',
            value: game.developer || ''
        },
        {
            label: 'Rating',
            value: game.rating || ''
        },
        {
            label: 'Released',
            value: new Date(game.releaseDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        },
        {
            label: 'Last Updated',
            value: new Date(game.updated_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        },
        {
            label: 'Technology',
            value: game.technology || 'HTML5'
        },
        {
            label: 'Platforms',
            value: game.platforms || (game.is_mobile_ready ? 'Web, Mobile' : 'Web')
        }
    ];

    return (
        <>
            <div className={`${styles.game_content} ${isMobile ? styles.mobile : ''}`}>
                {/* 面包屑路径 */}
                <div className={styles.path}>
                    {formatPath(game)}
                </div>
                
                {/* 游戏标题和封面 */}
                <div className={styles.title}>
                    <div className={styles.cover_image_block}>
                        <Image
                            src={game.cover_image}
                            alt={`Game ${game.name}`}
                            className={styles.image}
                        />
                    </div>
                    <div className={styles.game_name}>
                        <h1 style={{fontSize: "24px"}}>{game.name}</h1>
                    </div>
                </div>

                {/* 游戏详情信息 */}
                <div className={styles.game_content_detail}>
                    {gameDetailInfo.map((item, index) => (
                        item.value && (
                            <div key={index} className={styles.detail_item}>
                                <div className={styles.detail_label}>{item.label}</div>
                                <div className={styles.detail_value}>{item.value}</div>
                            </div>
                        )
                    ))}

                    {/* tags */}
                    <div className={styles.tag_group}>
                        {game.tags?.map((tag) => (
                            <div key={tag.id} className={styles.tag_item}>
                                <span className={styles.tag_name}>{tag.name}</span>
                                <span className={styles.tag_count}>{tag.gameCount}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 游戏描述 */}
            <div className={styles.game_content}>
                <div className={styles.introduction_title}>
                    <Gamepad2 size={24} color="#000000"/>
                    <h2 className={styles.introduction_title_text}>Introduction</h2>
                </div>
                <div className={styles.introduction_content}>{game.description}</div>
            </div>
        </>
    );
}